export default __webpack_public_path__ + "static/media/grua.560da976.png";